export default {"src":"/_next/static/media/onepager-pdf-img.8eb96538.svg","height":74,"width":60};